(function () {
	const SLIDER_SELECTORS = [
		'.js-product-slideshow',
		'.js-swiper-product-carousel',
		'.js-recommendation-swiper'
	];
	let lazySliderObserver = null;

	const getScope = (element) => {
		return element.closest('.js-get-section') || element.closest('section') || element.parentElement;
	};

	const getConfig = (element) => {
		const dataset = element.dataset;
		const slidesMobile = parseFloat(dataset.slidesMobile) ||
			parseFloat(dataset.mobileLayout) ||
			2.5;
		const slidesDesktop = parseFloat(dataset.slidesDesktop) || slidesMobile;
		const breakpoint = parseInt(dataset.breakpoint, 10) || 990;
		const breakpoint2 = dataset.breakpoint2 ? parseInt(dataset.breakpoint2, 10) : null;
		const slidesDesktop2 = dataset.slidesDesktop2 ? parseFloat(dataset.slidesDesktop2) : null;
		return {
			slidesMobile,
			slidesDesktop,
			breakpoint,
			breakpoint2,
			slidesDesktop2,
			spaceBetween: parseInt(dataset.spaceBetween, 10) || 24,
			speed: parseInt(dataset.speed, 10) || 600,
			scrollbar: dataset.scrollbar !== 'false',
			slidesOffsetAfter: dataset.slidesOffsetAfter !== undefined
				? parseInt(dataset.slidesOffsetAfter, 10)
				: null
		};
	};

	const findNavElements = (scope, swiperEl) => {
		const prev = scope.querySelector('.js-product-slideshow-prev') ||
			scope.querySelector('.js-product-carousel-arrow-prev') ||
			scope.querySelector('.product-recommendations__slider-nav .swiper-button-prev');
		const next = scope.querySelector('.js-product-slideshow-next') ||
			scope.querySelector('.js-product-carousel-arrow-next') ||
			scope.querySelector('.product-recommendations__slider-nav .swiper-button-next');
		const scrollbar = scope.querySelector('.js-product-slideshow-scrollbar') ||
			scope.querySelector('.js-product-carousel-swiper-scrollbar');
		return { prev, next, scrollbar };
	};

	const initProductSlideshow = (swiperEl) => {
		if (!swiperEl || swiperEl.classList.contains('swiper-initialized')) return null;

		const scope = getScope(swiperEl);
		const config = getConfig(swiperEl);
		const { prev, next, scrollbar } = findNavElements(scope, swiperEl);

		const breakpoints = {
			[config.breakpoint]: {
				slidesPerView: config.slidesDesktop,
				spaceBetween: config.spaceBetween,
				slidesOffsetAfter: 0
			}
		};
		if (config.breakpoint2 && config.slidesDesktop2 !== null) {
			breakpoints[config.breakpoint2] = {
				slidesPerView: config.slidesDesktop2,
				spaceBetween: config.spaceBetween,
				slidesOffsetAfter: 0
			};
		}

		const swiperConfig = {
			slidesPerView: config.slidesMobile,
			spaceBetween: config.spaceBetween,
			speed: config.speed,
			breakpoints,
			navigation: (prev && next) ? {
				prevEl: prev,
				nextEl: next
			} : undefined
		};

		if (config.slidesOffsetAfter !== null) {
			swiperConfig.slidesOffsetAfter = config.slidesOffsetAfter;
		}

		if (config.scrollbar && scrollbar) {
			swiperConfig.scrollbar = {
				el: scrollbar,
				draggable: true
			};
		}

		const swiper = new Swiper(swiperEl, swiperConfig);

		const navTools = scope.querySelector('.product-carousel_nav-tools');
		if (navTools && prev && next) {
			const checkNavVisibility = () => {
				const prevLocked = prev.classList.contains('swiper-button-lock');
				const nextLocked = next.classList.contains('swiper-button-lock');
				navTools.style.display = (prevLocked && nextLocked) ? 'none' : '';
			};
			swiper.on('init', checkNavVisibility);
			swiper.on('slideChange', checkNavVisibility);
		}

		swiperEl.classList.add('swiper-visible');

		return swiper;
	};

	const getLazySliderObserver = () => {
		if (!('IntersectionObserver' in window)) return null;
		if (lazySliderObserver) return lazySliderObserver;

		lazySliderObserver = new IntersectionObserver((entries, observer) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return;
				observer.unobserve(entry.target);
				initProductSlideshow(entry.target);
			});
		}, { rootMargin: '400px 0px' });

		return lazySliderObserver;
	};

	const queueProductSlideshow = (swiperEl) => {
		if (!swiperEl || swiperEl.classList.contains('swiper-initialized')) return;

		if (window.Shopify?.designMode) {
			initProductSlideshow(swiperEl);
			return;
		}

		const observer = getLazySliderObserver();
		if (!observer) {
			initProductSlideshow(swiperEl);
			return;
		}

		if (swiperEl.dataset.productSlideshowObserved === 'true') return;
		swiperEl.dataset.productSlideshowObserved = 'true';
		observer.observe(swiperEl);
	};

	const initProductSlideshows = (root = document) => {
		const elements = new Set();
		for (const selector of SLIDER_SELECTORS) {
			for (const el of root.querySelectorAll(selector)) {
				elements.add(el);
			}
		}
		elements.forEach((el) => queueProductSlideshow(el));
	};

	window.initProductSlideshows = initProductSlideshows;

	document.addEventListener('DOMContentLoaded', () => initProductSlideshows());
	document.addEventListener('shopify:section:load', () => initProductSlideshows());
})();
